import React, { useEffect, useState, memo } from 'react';
import { PwaLoader, ToastContainer } from '../';
import { PagesConnector } from '../ModulePage';
import { AccountConnector } from '../ModuleAccount';
import { AuthConnector } from '../ModuleAuth';
import { AppContent } from './AppContent';
export var AppInitializer = memo(function (_a) {
    var loaderText = _a.loaderText, accountRoute = _a.accountRoute, signOutRoute = _a.signOutRoute, children = _a.children;
    var _b = useState(false), appIsLoaded = _b[0], setAppIsLoaded = _b[1];
    useEffect(function () { return setAppIsLoaded(true); }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement(ToastContainer, { autoClose: 2000, draggable: true }),
        React.createElement(AuthConnector, null),
        React.createElement(AccountConnector, null),
        React.createElement(PagesConnector, null),
        !appIsLoaded
            ? React.createElement(PwaLoader, { text: loaderText })
            : React.createElement(AppContent, { signOutRoute: signOutRoute, accountRoute: accountRoute }, children)));
});
